<h1 mat-dialog-title>Add {{article}} {{typeName}}</h1>
<mat-dialog-content autocomplete="off">
    <app-select-node [nodes]="data.nodes" [search]="true" [label]="typeName === 'node' ? 'Node' : (typeName.charAt(0).toUpperCase() + typeName.slice(1))" placeholder="Type to find one, or a new name" (selectedNodeChange)="onChange($event)" (nameTyped)="onNameTyped($event)"></app-select-node>
    <p class="message">{{getMessage()}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="onSaveClick()" [disabled]="!canSave()">{{selectedNode ? 'Add' : 'Create and add'}}</button>
</mat-dialog-actions>
